import { default as axios } from './axiosConfig'
import type { RolePermissionApiRow } from '@utils/staffPermission.util'
import { getEnv } from '@utils/env'
import type {
  StaffPermissionRole,
  StaffScope,
} from '@constants/Settings/staffPermission.const'
import { toApiError } from './errors/api-error'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_PROVIDER')

const headers = {
  'Content-Type': 'application/json',
}

export type RolePermissionUpsertDto = {
  work_role: StaffPermissionRole
  scopes: StaffScope[]
}

interface RolePermissionsApiResponse {
  statusCode: number
  message: string
  data: {
    role_permissions: RolePermissionApiRow[]
  }
}

export const getRolePermissions =
  async (): Promise<RolePermissionsApiResponse> => {
    try {
      const { data, status } = await axios.get<RolePermissionsApiResponse>(
        `${BUSINESS_LAYER_API}/api/v1/rolepermissions`,
        { headers },
      )
      if (status !== 200) {
        throw new Error('Failed to fetch role permissions')
      }
      return data
    } catch (e) {
      throw toApiError(e, 'Error fetching role permissions')
    }
  }

export const saveRolePermissions = async (
  roles: RolePermissionUpsertDto[],
): Promise<RolePermissionsApiResponse> => {
  try {
    const { data, status } = await axios.put<RolePermissionsApiResponse>(
      `${BUSINESS_LAYER_API}/api/v1/rolepermissions`,
      { roles },
      { headers },
    )
    if (status !== 200) {
      throw new Error('Failed to save role permissions')
    }
    return data
  } catch (e) {
    throw toApiError(e, 'Error saving role permissions')
  }
}
